import { ActionParams } from '../../../types/constants'
import { ActionsList, FrequenciesList, UpdateReportAdTypes } from '../../../util/contstants'
import ModelsRecipe = Models.Recipe
export interface Recipe extends ModelsRecipe {
    action_params: ActionParams
}
import { State } from '../../../constants'

export const DefaultRecipe: Recipe = {
    name: 'New Recipe',
    ad_type: UpdateReportAdTypes.Campaigns,
    enabled: false,
    trigger: 'over the last 30 days acos > 20% and spend > $10',
    action: ActionsList.SetState,
    action_params: {
        type: ActionsList.SetState,
        extra: State.Paused,
    },
    frequency: FrequenciesList.Manually,
    frequency_params: null,
    last_run: null,
    last_change: null,
    version: 1,
}

export const newDefaultRecipe = (version: number): Recipe => {
    const recipe = {
        ...DefaultRecipe,
    }

    if (version === 2) {
        recipe.name = 'New Segment'
        recipe.ad_type = UpdateReportAdTypes.Targets
        recipe.trigger = 'acos(30d) > 20% and spend(30d) > $10'
        recipe.version = 2
    }

    return recipe
}
